import { message } from "antd"

export default (content, copySuccessMessage, copyFailMessage) => {
  let targetId = "_hiddenCopyText_"
  let currentFocus = document.activeElement
  let target = document.getElementById(targetId)
  currentFocus.focus()

  // 如果不是，则使用节点的textContent
  if (!target) {
      //如果不存在，则创建一个
      target = document.createElement("textarea")
      target.style.position = "absolute"
      target.style.left = "-9999px"
      target.style.top = "0"
      target.id = targetId
      document.body.appendChild(target)
  }
  target.textContent = content
  // 聚焦目标节点，选中它的内容
  target.focus()
  target.setSelectionRange(0, target.value.length)

  // 进行复制操作
  try {
    document.execCommand("copy")
    message.success(copySuccessMessage || "复制成功")
  } catch(e) {
    message.error(copyFailMessage || "复制失败")
  }

  // 不再聚焦
  if (currentFocus && typeof currentFocus.focus === "function") {
    currentFocus.focus()
  }

   // 清空临时数据
   target.textContent = ""
}



// WEBPACK FOOTER //
// ./src/app/utils/copyText.js